const BUNDLED_WORKER_RE = /(?:^|\/)static\/media\/pdf\.worker(?:\.min)?(?:\.[^/?#]+)?\.mjs(?:[?#].*)?$/i;

let cachedWorkerModuleUrl = "";
let cachedWorkerSrc = "";

function trimTrailingSlash(value) {
  return String(value || "").trim().replace(/\/+$/, "");
}

function getBrowserOrigin() {
  if (typeof window === "undefined" || !window.location?.origin) return "";
  return window.location.origin;
}

function toAbsoluteUrl(url) {
  const value = String(url || "").trim();
  if (!value) return "";

  try {
    return new URL(value, getBrowserOrigin() || undefined).toString();
  } catch (_) {
    return value;
  }
}

function isBundledWorkerUrl(url) {
  return BUNDLED_WORKER_RE.test(toAbsoluteUrl(url));
}

function getLocalApiBase() {
  if (typeof window === "undefined") return "http://localhost:3001";
  const host = window.location?.hostname;
  if (host === "localhost" || host === "127.0.0.1") return "http://localhost:3001";
  return "";
}

function getWorkerProxyUrl(pdfjsVersion) {
  const apiBase = trimTrailingSlash(process.env.REACT_APP_API_URL) || getLocalApiBase();
  if (!apiBase) return "";

  const versionQuery = encodeURIComponent(pdfjsVersion || "unknown");
  return `${apiBase}/chat/pdf-worker?pdfjs=${versionQuery}`;
}

function getCdnWorkerUrl(pdfjsVersion) {
  const version = encodeURIComponent(pdfjsVersion || "4.8.69");
  return `https://unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;
}

export function resolvePdfWorkerModuleUrl(pdfjsVersion) {
  const configuredUrl = String(process.env.REACT_APP_PDF_WORKER_URL || "").trim();
  if (configuredUrl && !isBundledWorkerUrl(configuredUrl)) {
    return toAbsoluteUrl(configuredUrl);
  }

  return getWorkerProxyUrl(pdfjsVersion) || getCdnWorkerUrl(pdfjsVersion);
}

function createBlobWorkerSrc(workerModuleUrl) {
  if (
    typeof Blob === "undefined" ||
    typeof URL === "undefined" ||
    typeof URL.createObjectURL !== "function"
  ) {
    return workerModuleUrl;
  }

  const workerBootstrap = `export { WorkerMessageHandler } from ${JSON.stringify(workerModuleUrl)};`;
  const workerBlob = new Blob([workerBootstrap], { type: "text/javascript" });
  return URL.createObjectURL(workerBlob);
}

export function configurePdfJsWorker(pdfjs) {
  const workerModuleUrl = resolvePdfWorkerModuleUrl(pdfjs?.version);
  if (!workerModuleUrl) return "";

  if (cachedWorkerModuleUrl !== workerModuleUrl) {
    cachedWorkerModuleUrl = workerModuleUrl;
    cachedWorkerSrc = createBlobWorkerSrc(workerModuleUrl);
  }

  if (pdfjs?.GlobalWorkerOptions) {
    pdfjs.GlobalWorkerOptions.workerSrc = cachedWorkerSrc;
  }

  return cachedWorkerSrc;
}
